import { Select } from "antd";
import { useListar } from "../../../../../../Services/Financeiro/Faturamento/Imposto/RegimeTributarioServices";
import { SelectComPesquisa } from "../../../../../SelectComPesquisa";
import RegimeTributario from "../../../../../../Models/Financeiro/Faturamento/Imposto/RegimeTributario";

interface IRegimeTributarioSelectMultProps extends Omit<React.ComponentProps<typeof Select>, "value" | "onChange" | "showSearch" | "optionFilterProp" | "filterOption"> {
    onChange?:(value:RegimeTributario[]) => void;
    value?:RegimeTributario[];
}
export default function RegimeTributarioSelectMult({
    onChange,
    value,
    ...props
}:IRegimeTributarioSelectMultProps) {
    const {
        data,
        isLoading
    } = useListar({});

    return <SelectComPesquisa 
        {...props}
        placeholder={"Todos"}
        allowClear
        mode="multiple"
        loading={isLoading}
        onChange={(v) => {
            const values = v as number[] ?? [];
            onChange?.(values.map(m => data?.find(f => f.codigo == m)).filter(f => !!f) ?? []);
        }}
        value={(value as RegimeTributario[] ?? []).map(m => m.codigo)}
        options={data?.map(m => {
            return {
                value : m.codigo,
                label : m.nome
            }
        })}
    />
}